import { render, staticRenderFns } from "./add.vue?vue&type=template&id=78817bf4&"
import script from "./add.ts?vue&type=script&lang=ts&"
export * from "./add.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports